module.exports = __webpack_public_path__ + "assets/images/link8c1942c57cace62af1a465201bfc7423.svg";